import Modal from "app/components/Modal";
import { selectSelectedTeam, selectUserFormData } from "app/redux/selector";
import { useQueryState } from "nuqs";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  selectTicketCreateLoading,
  selectTicketFormDetail,
} from "../../containers/Tickets/redux/selector";
import { ticketGroupsActions } from "../../containers/Tickets/redux/slice";
import { actions } from "../../redux/slice";
import { selectDraftBoardForm } from "../Settings/redux/selector";
import AddTaskHeader from "../AddTaskHeader";
import AddTaskModalContent from "./AddTaskModalContent";
import DraftModal from "./draft-modal";
import { IWorkspaceProjects, IWorkspaceTeams } from "app/types";
import { useApplyDefaultTicketValues } from "app/containers/Features/containers/Boards/hooks/useApplyDefaultTicketValues";
interface AddTaskModalProps {
  onClose: () => void;
  isDrafted?: boolean;
  title?: string;
  sprintName?: string;
  createTicketForHome?: boolean;
  isAddEpicModal?: boolean;
}

export default function AddTaskModal({
  onClose,
  isDrafted,
  title,
  sprintName,
  createTicketForHome = false,
  isAddEpicModal = false,
}: AddTaskModalProps) {
  const { id } = useParams();
  const loading = useSelector(selectTicketCreateLoading);
  const form = useSelector(selectTicketFormDetail);
  const [draftId, setDraftId] = useQueryState("did");
  const [deleteDraft, setDeleteDraft] = useState(false);
  const dispatch = useDispatch();
  const selectedTeam = useSelector(selectSelectedTeam);
  const boardForm = useSelector(selectDraftBoardForm);
  const { selectedProjectId } = useSelector(selectUserFormData); // user workspace details
  useApplyDefaultTicketValues(boardForm?.defaultTicketValues, form);

  const projects = useMemo(
    () => selectedTeam?.projects?.find((p) => p?._id === selectedProjectId),
    [selectedTeam, selectedProjectId],
  );

  const handleClose = () => {
    if (isDrafted) {
      setDeleteDraft(true);
      return;
    } else {
      onClose();
    }
  };
  const handleSetDraft = () => {
    onClose();

    dispatch(actions.setDraftTicket());
  };
  const handleRemoveDraft = (id: string) => {
    dispatch(actions.removeDraftTicket({ id: id }));
    setDeleteDraft(false);
    setDraftId(null);
  };
  const onSubmit = () => {
    dispatch(
      ticketGroupsActions.setCreateTicket({
        projectId: selectedProjectId,
        boardId: id as string,
        groupId: "",
        callback: () => {
          dispatch(ticketGroupsActions.clearCreateTicketForm());
          onClose();
        },
      }),
    );
  };

  return (
    <div className=" relative ">
      <Modal
        onClose={handleClose}
        title={title ? title : isDrafted ? "Task Draft" : "Add task"}
        submitText="Save"
        submitLoading={loading}
        isSubmitDisabled={!form.title}
        onSubmit={onSubmit}
        contentClassName="!p-0 !max-h-[50vh] overflow-y-auto "
        modalClassName="!w-[721px] !max-w-[721px] "
        renderModalHeader={
          <AddTaskHeader
            isDrafted={isDrafted as boolean}
            handleSetDraft={handleSetDraft}
            handleClose={handleClose}
            handleRemoveDraft={() => {
              handleRemoveDraft(draftId as string);
            }}
            title={title ? title : isDrafted ? "Task Draft" : "Add task"}
          />
        }
      >
        <AddTaskModalContent
          sprintName={sprintName as string}
          selectedTeam={selectedTeam as IWorkspaceTeams}
          selectedProject={projects as IWorkspaceProjects}
          createTicketForHome={createTicketForHome as boolean}
          isAddEpicModal={isAddEpicModal}
        />
      </Modal>
      {deleteDraft && (
        <DraftModal
          setDeleteDraft={setDeleteDraft}
          handleRemoveDraft={() => {
            handleRemoveDraft(draftId as string);
          }}
          onClose={onClose}
          setDraftId={setDraftId}
        />
      )}
    </div>
  );
}
